import React from "react";

export const Home: React.FC = () => {
  return null;
};
